// Registro do módulo de autorização (Parte 5.9; GIY-056): na rede sob `authz.read`, no tenant sob
// `authz.assignment.read.tenant` ou, para o delegation log (GIY-075), `delegation.read`/`delegation.manage` (any-of); as rotas `/me/access-reviews`,
// `/me/two-key` e `/me/delegations` são registradas à mão no roteador.
import type { ModuleDefinition } from '../types';

export const authzModule: ModuleDefinition = {
  key: 'authz',
  milestone: 'M4',
  network: { path: 'authz', permission: 'authz.read', labelKey: 'authz' },
  tenant: {
    path: 'authz',
    permission: ['authz.assignment.read.tenant', 'delegation.read', 'delegation.manage'],
    labelKey: 'authz',
  },
  load: () => import('./AuthzModule'),
};
